<template>
    <section class="mb-3">
        <div class="row" v-if="!signatureUrl">
            <div class="col-md-12">
                <button
                    @click.prevent="openCustomSignatureModal()"
                    class="mt-2 px-0 btn btn-link text-primary text-uppercase font-weight-bold"
                >
                    Add {{ name }} Signature >
                </button>
            </div>
        </div>
        <div class="row" v-if="signatureUrl">
            <div class="col-md-12">
                <img id="signature" class="mt-2 signatureWrapper" :src="signatureUrl" alt="" />
                <div class="clearfix"></div>
                <button
                    @click="cancel()"
                    class="mt-1 px-0 btn btn-link btn-sm text-uppercase font-weight-bold pull-left"
                >
                    Cancel
                </button>
                <button
                    @click.prevent="openCustomSignatureModal()"
                    class="mt-1 px-0 btn btn-link btn-sm text-uppercase font-weight-bold pull-right"
                >
                    Update Signature
                </button>
            </div>
        </div>
        <modal-component
            :id="`upload-signature-modal-${canvasId}`"
            :visible="signatureModal.visible"
            :title="signatureModal.title"
            :size="signatureModal.size"
            @close="resetModal()"
        >
            <div>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="p-2 bg-white">
                            <a
                                @click="clearSignature"
                                class="font-weight-bold link-primary float-right text-primary cursor-pointer"
                                >Clear</a
                            >
                            <h5 class="mb-3 text-uppercase font-weight-bold">
                                {{ name }} Signature
                            </h5>
                            <canvas :id="canvasId" class="signatureWrapper"></canvas>
                            <i>*Please sign in the box above</i>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-12">
                        <div class="p-2">
                            <button
                                class="btn btn-primary pull-right"
                                @click.prevent="saveSignature()"
                            >
                                <i class="fa fa-save"></i> Save
                            </button>
                            <div class="clearfix"></div>
                            <small
                                v-if="signatureError"
                                class="text-primary font-italic pull-left"
                                >{{ signatureError }}</small
                            >
                        </div>
                    </div>
                </div>
            </div>
        </modal-component>
    </section>
</template>
<script>
import SignaturePad from "signature_pad";
import ModalComponent from "./ModalComponent.vue";

export default {
    components: { ModalComponent },
    name: "CustomSignature",
    props: ["name", "canvasId", "signatureTitle"],
    data() {
        return {
            signatureModal: {
                visible: false,
                size: "lg",
                title: null,
            },
            signaturePad: null,
            signatureError: null,
            signatureUrl: null,
        };
    },
    methods: {
        resetModal() {
            this.signatureModal.visible = false;
        },
        openCustomSignatureModal() {
            const canvas = document.querySelector(`#${this.canvasId}`);
            this.signaturePad = new SignaturePad(canvas);
            this.signatureModal.visible = true;
        },

        saveSignature() {
            this.signatureError = null;
            if (this.signaturePad.isEmpty()) {
                this.signatureError = "Please sign before saving";
                return;
            }
            let url = this.signaturePad.toDataURL();
            this.signatureUrl = url;
            this.$emit("created", url);
            this.resetModal();
        },

        clearSignature() {
            this.signaturePad.clear();
        },

        cancel() {
            this.signatureUrl = null;
            this.$emit("cancel");
        },
    },
};
</script>

<style scoped>
.signatureWrapper {
    width: 100%;
    border: 1px solid lightgray;
}
.link-danger {
    color: red;
}
</style>
